//@ts-nocheck

import styled, { css } from "styled-components";
import { Container, Row, Col } from "../../../atoms/GridSystem";

export const MenuMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  top: ${({ theme }) => theme.rem(72)};
  left: 0;
  width: 100%;
  height: calc(100svh - ${({ theme }) => theme.rem(72)});
  z-index: 100;
  transform: translateX(-100%);
  transition: transform 0.2s ease-out;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: ${({ theme }) => theme.rem(24)};
  background-color: ${({ theme }) => theme.colorScheme['header'].surface.inside};

  ${({ isOpen }) => isOpen && css`
    transform: translateX(0);
  `}

  ${Col} {
    &:not(:last-child) {
      margin-bottom: ${({ theme }) => theme.rem(16)};

      ${({ theme }) => theme.mediaQuery.md(`
        margin-bottom: ${theme.rem(8)};
      `)};

      ${({ theme }) => theme.mediaQuery.lg(`
        margin-bottom: ${theme.rem(16)};
      `)};
    }

    > * {
      &:not(:last-child) {
        margin-bottom: ${({ theme }) => theme.rem(16)};

        ${({ theme }) => theme.mediaQuery.md(`
          margin-bottom: ${theme.rem(8)};
        `)};

        ${({ theme }) => theme.mediaQuery.lg(`
          margin-bottom: ${theme.rem(16)};
        `)};
      }
    }
  }
`

export const MenuMobileServiceWrapper = styled.div`
  width: 100%;

  > * {
    background-color: #EEE;

    &:not(:last-child) {
      margin-bottom: ${({ theme }) => theme.rem(16)};

      ${({ theme }) => theme.mediaQuery.md(`
        margin-bottom: ${theme.rem(8)};
      `)};

      ${({ theme }) => theme.mediaQuery.lg(`
        margin-bottom: ${theme.rem(16)};
      `)};
    }
  }
`

export const MenuMobileFirstLevel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(16)};

  ${({ theme }) => theme.mediaQuery.md(`
    gap: ${theme.rem(8)};
  `)};

  ${({ theme }) => theme.mediaQuery.lg(`
    gap: ${theme.rem(16)};
  `)};

  ${Row} {
    &:not(:last-child) {
      margin-bottom: ${({ theme }) => theme.rem(16)};

      ${({ theme }) => theme.mediaQuery.md(`
        margin-bottom: ${theme.rem(8)};
      `)};

      ${({ theme }) => theme.mediaQuery.lg(`
        margin-bottom: ${theme.rem(16)};
      `)};
    }
  }
`

export const MenuMobileSecondLevel = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(16)};
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(100%);
  transition: transform 0.2s ease-out;
  background-color: white;

  ${({ theme }) => theme.mediaQuery.md(`
    gap: ${theme.rem(8)};
  `)};

  ${({ theme }) => theme.mediaQuery.lg(`
    gap: ${theme.rem(16)};
  `)};

  ${({ isOpen }) => isOpen && css`
    transform: translateX(0);
  `}
`